import React from 'react';
import { styled } from '@linaria/react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { animated } from 'react-spring';
import { motion } from 'framer-motion';

interface Props extends React.ComponentProps<typeof motion.div> {
  fontSize: number;
  marginBottom: number;
  animateTransitions: boolean;
}

function EmBoxArrow({
  fontSize,
  marginBottom,
  animateTransitions,
}: Props) {
  const distance = fontSize * marginBottom;

  return (
    <Wrapper
      // @ts-ignore
      as={animateTransitions ? motion.div : 'div'}
      style={{
        width: 20,
        height: animateTransitions ? undefined : distance,
      }}
      animate={{
        height: animateTransitions ? distance : undefined,
      }}
    >
      <ArrowWrapper style={{ opacity: distance < 16 ? 0 : 1 }}>
        <VerticalArrowElem>
          <Up size={20} />
          <Down size={20} />
          <VerticalShaft />
        </VerticalArrowElem>
      </ArrowWrapper>
      <VerticalLabel>
        {fontSize} × {marginBottom} = {Math.round(distance)}px
      </VerticalLabel>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  position: relative;
`;

const ArrowWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: opacity 200ms;
`;

const ArrowElem = styled.div`
  width: 100%;
  height: 100%;
  color: var(--color-gray-700);
  transform-origin: bottom center;
  backface-visibility: hidden;
  will-change: transform;
`;

const VerticalArrowElem = styled(ArrowElem)`
  animation: verticalEnter 250ms;

  @keyframes verticalEnter {
    from {
      transform: translateY(25%) scaleY(0.5);
      opacity: 0;
    }
    to {
      transform: translateY(0px) scaleY(1);
      opacity: 1;
    }
  }
`;
const Up = styled(ChevronUp)`
  position: absolute;
  top: -6px;
`;
const Down = styled(ChevronDown)`
  position: absolute;
  bottom: -6px;
`;

const Shaft = styled.div`
  position: absolute;
  margin: auto;
  background: var(--color-gray-700);
  border-radius: 10px;
`;

const VerticalShaft = styled(Shaft)`
  top: 2px;
  bottom: 2px;
  left: 0;
  right: 0;
  width: 2px;
`;

const Label = styled(animated.span)`
  position: absolute;
  height: 0.75rem;
  line-height: 0.75rem;
  font-size: 0.75rem;
  font-weight: var(--font-weight-medium);
  margin: auto;
`;

const VerticalLabel = styled(Label)`
  top: 0;
  bottom: 0;
  left: 28px;
  width: max-content;
`;

export default EmBoxArrow;
